export const FIXTURES_REGISTER_FILE_NAME = "FixturesRegister";
